import {genCompositeId} from 'module/Properties/util/PropertiesUtil';
import {getAppName} from 'util/AppName';
import {PropertyTypeEnum} from 'module/Properties/enum/PropertyTypeEnum'

export class PropertyID {
	readonly object: string
	readonly subkrit: string | undefined
	readonly attribute: string
	readonly type: PropertyTypeEnum

	/**
	 * @param object
	 * @param attribute
	 * @param type
	 * @param subkrit only for paramdiv
	 */
	constructor(object: string, attribute: string, type: PropertyTypeEnum = PropertyTypeEnum.UserProperty, subkrit?: string) {
		this.object = type === PropertyTypeEnum.VirtualProperty ? 'evoApps' : object
		this.subkrit = subkrit
		this.attribute = attribute
		this.type = type
	}

	toString() {
		return genCompositeId(this.object, this.attribute, this.type, this.subkrit);
	}
}


const appName = getAppName()

/**
 * define ids of properties here for easy usage
 * @type {*} enum
 */
export const PropID = {
	evoApps_personListTemplate: new PropertyID("evoApps", "personListTemplate"),
	evoApps_KostListTemplate: new PropertyID("evoApps", "kostListTemplate"),
	evoApps_showPersonInfoButtonInSidePanel: new PropertyID('evoApps', 'showPersonInfoButtonInSidePanel'),
	showPersonPhoto: new PropertyID(appName, 'showPersonPhoto'),
	farbeOhneSoll: new PropertyID(appName, "farbeOhneSoll"),
	evoApps_dayInfoColors: new PropertyID("evoApps", "farbenSollIst"),
	evoApps_dayInfoColorsMaxLimit: new PropertyID("evoApps", "farbenSollIstMaxLimit"),
	evoApps_durFormat: new PropertyID("sisworld.sfa.appservlet.sissfamodule", "DurFormat", PropertyTypeEnum.IProperty),
	evoApps_askForBigSelectionAmountInSelPan: new PropertyID("evoApps", "askForBigSelectionAmountInSelPan"),
	evoApps_mailVertretungMaxAmount: new PropertyID("evoApps", "mailVertretungMaxAmount"),
	evoApps_mailVertretungAllowFwd: new PropertyID("evoApps", "mailVertretungAllowFwd"),
	evoApps_mailVertretungGlobalFwdSwitch: new PropertyID("evoApps", "mailVertretungGlobalFwdSwitch"),
	evoApps_showStuartBuartShortKey: new PropertyID("evoApps", "showStuartBuartShortKey"),
	evoApps_notiButtonShowAlways: new PropertyID("evoApps", "notiButtonShowAlways"),
	evoApps_newAzeDialog: new PropertyID("evoApps", "newAzeDialog"),
	evoApps_passwordStrength: new PropertyID("evoApps", "passwordStrength"),
	home_showVersionInfo: new PropertyID('home', 'showVersionInfo'),
	home_warnIE11: new PropertyID('home', 'warnIE11'),
	eventDialog_print: new PropertyID("eventDialog", "drucken"),
	eventDialog_favDefault: new PropertyID("eventDialog", "favDefault"),
	eventDialog_geoMapAttribution: new PropertyID("eventDialog", "geoMapAttribution"),
	workflow_pageSize: new PropertyID("workflow", "pageSize"),
	workflow_bulkGenAbl: new PropertyID(appName, "bulkGenAbl"),
	bookingCalendar_bewertungButton: new PropertyID("bookingCalendar", "bewertungButton"),
	bookingCalendar_bookingButton: new PropertyID("bookingCalendar", "bookingButton"),
	bookingCalendar_bplanButton: new PropertyID("bookingCalendar", "bplanButton"),
	bookingCalendar_buchungsschlussButton: new PropertyID("bookingCalendar", "buchungsschlussButton"),
	bookingCalendar_persurlButton: new PropertyID("bookingCalendar", "persurlButton"),
	bookingCalendar_kontierungButton: new PropertyID("bookingCalendar", "kontierungButton"),
	bookingCalendar_wocheFreigebenButton: new PropertyID("bookingCalendar", "wocheFreigebenButton"),
	bookingCalendar_wochenBelegButton: new PropertyID("bookingCalendar", "wochenBelegButton"),
	bookingCalendar_teamcalendarButton: new PropertyID("bookingCalendar", "teamcalendarButton"),
	bookingCalendar_dragAndDropEvents: new PropertyID("bookingCalendar", "dragAndDropEvents"),
	bookingCalendar_resizeEvents: new PropertyID("bookingCalendar", "resizeEvents"),
	bookingCalendar_viewMonthButton: new PropertyID("bookingCalendar", "viewMonthButton"),
	bookingCalendar_viewWeekButton: new PropertyID("bookingCalendar", "viewWeekButton"),
	bookingCalendar_viewDayButton: new PropertyID("bookingCalendar", "viewDayButton"),
	resourceCalendar_personPageSize: new PropertyID("resourceCalendar", "personPageSize"),
	resourceCalendar_showPresencePlanning: new PropertyID("resourceCalendar", "showPresencePlanning"),
	resourceCalendar_showPresencePlanningAbsent: new PropertyID("resourceCalendar", "showPresencePlanningAbsent"),
	resourceCalendar_showSumAnwesend: new PropertyID("resourceCalendar", "showSumAnwesend"),
	resourceCalendar_showSumAbwesend: new PropertyID("resourceCalendar", "showSumAbwesend"),
	resourceCalendar_showSumAbwesendPersurl: new PropertyID("resourceCalendar", "showSumAbwesendPersurl"),
	resourceCalendar_showSumAbwesendPersurlSoll: new PropertyID("resourceCalendar", "showSumAbwesendPersurlSoll"),
	resourceCalendar_showSumSoll: new PropertyID("resourceCalendar", "showSumSoll"),
	resourceCalendar_rowHeaderMinWidth: new PropertyID("resourceCalendar", "rowHeaderMinWidth"),
	resourceCalendar_bookingButton: new PropertyID("resourceCalendar", "bookingButton"),
	resourceCalendar_persurlButton: new PropertyID("resourceCalendar", "persurlButton"),
	resourceCalendar_dragAndDropEvents: new PropertyID("resourceCalendar", "dragAndDropEvents"),
	resourceCalendar_resizeEvents: new PropertyID("resourceCalendar", "resizeEvents"),
	resourceCalendar_viewMonthButton: new PropertyID("resourceCalendar", "viewMonthButton"),
	resourceCalendar_viewWeekButton: new PropertyID("resourceCalendar", "viewWeekButton"),
	resourceCalendar_viewTwoWeekButton: new PropertyID("resourceCalendar", "viewTwoWeekButton"),
	sortAlwaysOnTop: new PropertyID(appName, "sortAlwaysOnTop"),
	sortAlwaysOnBottom: new PropertyID(appName, "sortAlwaysOnBottom"),
	onClient_disablePersonsByKost: new PropertyID("onClient", "disablePersonsByKost"),
	copyPaste: new PropertyID(appName, "copyPaste"),
	deleteMode: new PropertyID(appName, "deleteMode"),
	copyExcludedTypes: new PropertyID(appName, "copyExcludedTypes"),
	onClient_enableCopyPasteInMultiKost: new PropertyID("onClient", "enableCopyPasteInMultiKost"),
	onClient_multiKostInputShows: new PropertyID("onClient", "multiKostInputShows"),
	onClient_multiKostRememberChoice: new PropertyID("onClient", "multiKostRememberChoice"),
	onClient_multiKostInitWithStammKost: new PropertyID("onClient", "multiKostInitWithStammKost"),
	multiKostInitShowDialog: new PropertyID(appName, "multiKostInitShowDialog"),
	multiKostInitMaxAmount: new PropertyID(appName, "multiKostInitMaxAmount"),
	onClient_monthMode: new PropertyID('onClient', 'monthMode'),
	onClient_copyDoneMessage: new PropertyID('onClient', 'copyDoneMessage'),
	onClient_overviewButton: new PropertyID("onClient", "overviewButton"),
	onClient_personInfoButton: new PropertyID("onClient", "personInfoButton"),
	onClient_maxPageSize: new PropertyID('onClient', 'maxPageSize'),
	enableInitEntries: new PropertyID(appName, "enableInitEntries"),
	initMethod: new PropertyID(appName, 'initMethod'),
	initBerechoffcNoSoll: new PropertyID(appName, 'initBerechoffcNoSoll'),
	sheet_adaptStartTimeToEndTimeOfPrevious: new PropertyID('sheet', 'adaptStartTimeToEndTimeOfPrevious'),
	sheet_highlightDaysWithOverlappingBookings: new PropertyID('sheet', 'highlightDaysWithOverlappingBookings'),
	terminal_personInput: new PropertyID("terminal", "personInput"),
	terminal_showVlErrorsView: new PropertyID("terminal", "verrechnungsmeldungen"),
	terminal_padInputType: new PropertyID("terminal", "padInputType"),
	terminal_customFieldLabelPos: new PropertyID("terminal", "customFieldLabelPos"),
	terminal_showDefaultTextField: new PropertyID("terminal", "showDefaultTextField"),
	terminal_switchToTwoColumnAt: new PropertyID("terminal", "switchToTwoColumnAt"),
	terminal_bookingListTemplate: new PropertyID("terminal", "bookingListTemplate"),
	terminal_bookingListHideCfDef: new PropertyID("terminal", "bookingListHideCfDef"),
	terminal_bookingListShowDqLabelCfDef: new PropertyID("terminal", "bookingListShowDqLabelCfDef"),
	terminal_azeBookingListTemplate: new PropertyID("terminal", "azeBookingListTemplate"),
	terminal_clearCFBufferOnCancel: new PropertyID("terminal", "clearCFBufferOnCancel"),
	terminal_keepFormOpen: new PropertyID("terminal", "keepFormOpen"),
	terminal_allowOverrideTime: new PropertyID("terminal", "allowOverrideTime"),
	terminal_preventFutureBooking: new PropertyID("terminal", "preventFutureBooking"),
	terminal_maxPastPeriodBooking: new PropertyID("terminal", "maxPastPeriodBooking"),
	terminal_allowDeleteBookings: new PropertyID("terminal", "allowDeleteBookings"),
	terminal_allowDeletePersurls: new PropertyID("terminal", "allowDeletePersurls"),
	terminal_cfFormButtonLabelOK: new PropertyID('terminal', 'cfFormButtonLabelOK'),
	terminal_cfFormButtonLabelCancel: new PropertyID('terminal', 'cfFormButtonLabelCancel'),
	terminal_analogClock: new PropertyID('terminal', 'analogClock'),
	terminal_infoVisibilityDuration: new PropertyID('term', 'infoVisibilityDuration'),
	terminal_bookingListPos: new PropertyID('term', 'bookingListPos'),
	terminal_persurlListPos: new PropertyID('term', 'persurlListPos'),
	terminal_azeBokingListVis: new PropertyID('term', 'azeBokingListVis'),
	terminal_azeBokingListPos: new PropertyID('term', 'azeBokingListPos'),
	terminal_verrechnungsmeldungenPos: new PropertyID('term', 'verrechnungsmeldungenPos'),
	terminal_personInformationVis: new PropertyID('term', 'personInformationVis'),
	terminal_personInformationPos: new PropertyID('term', 'personInformationPos'),
	terminal_aktuelleKontierungVis: new PropertyID('term', 'aktuelleKontierungVis'),
	terminal_aktuelleKontierungPos: new PropertyID('term', 'aktuelleKontierungPos'),
	terminal_personInformationHeader: new PropertyID('term', 'personInformationHeader'),
	terminal_inactivityTime: new PropertyID('term', 'inactivityTime'),
	terminal_visibleEntryDescButtonLabel: new PropertyID("term", "visibleEntryDescButtonLabel"),
	terminal_typeGroupLabelLong: new PropertyID("term", "typeGroupLabelLong"),
	timelineTask_maxTasksSelected: new PropertyID("timelineTask", "maxTasksSelected"),
	planTemplate_pause: new PropertyID("planTemplate", "pause"),
	planTemplate_wochenTolera: new PropertyID("planTemplate", "wochenTolera"),
	planTemplate_showSoll: new PropertyID("planTemplate", "showSoll"),
	planTemplate_freigabe: new PropertyID("planTemplate", "freigabe"),
	planTemplate_enablePeriode: new PropertyID("planTemplate", "enablePeriode"),
	planTemplate_persNrMode: new PropertyID("planTemplate", "persNrMode"),
	planTemplate_enableEndDateInput: new PropertyID("planTemplate", "enableEndDateInput"),
	planTemplate_planPersDeletable: new PropertyID("planTemplate", "planPersDeletable"),
	planTemplate_planMastChangeableWhenPlanPersExists: new PropertyID("planTemplate", "planMastChangeableWhenPlanPersExists"),

	// ISS booking, booking-person
	booking_PersonenAnsichtButton: new PropertyID("booking", "bookingPersonenAnsichtButton"),
	booking_PersonPlusButton: new PropertyID("booking", "bookingPersonPlusButton"),
	booking_CopyButton: new PropertyID("booking", "bookingCopyButton"),
	booking_fehlerAuswertung: new PropertyID("booking", "fehlerauswertung"),
	booking_planing: new PropertyID("booking", "planing"),
	booking_addTaskBtn: new PropertyID("booking", "addTaskBtn"),
	booking_supplementBookingListBtn: new PropertyID("booking", "supplementBookingListBtn"),
	booking_supplementBookingEditBtn: new PropertyID("booking", "supplementBookingEditBtn"),
	booking_vorlageBtn: new PropertyID("booking", "vorlageBtn"),
	booking_monatsauswertungBtn: new PropertyID("booking", "monatsauswertungBtn"),
	booking_saldenInfoBtn: new PropertyID("booking", "saldenInfoBtn"),

	booking_person_PersonenAnsichtButton: new PropertyID("booking_person", "bookingPersonenAnsichtButton"),
	booking_person_PersonPlusButton: new PropertyID("booking_person", "bookingPersonPlusButton"),
	booking_person_CopyButton: new PropertyID("booking_person", "bookingCopyButton"),
	booking_person_fehlerAuswertung: new PropertyID("booking_person", "fehlerauswertung"),
	booking_person_planing: new PropertyID("booking_person", "planing"),
	booking_person_addPersonBtn: new PropertyID("booking_person", "addPersonBtn"),
	booking_person_supplementBookingListBtn: new PropertyID("booking_person", "supplementBookingListBtn"),
	booking_person_supplementBookingEditBtn: new PropertyID("booking_person", "supplementBookingEditBtn"),
	booking_person_vorlageBtn: new PropertyID("booking_person", "vorlageBtn"),
	booking_person_monatsauswertungBtn: new PropertyID("booking_person", "monatsauswertungBtn"),
	booking_person_saldenInfoBtn: new PropertyID("booking_person", "saldenInfoBtn"),

	// these only return true if menu allows these apps
	showBookingCalendarButton: new PropertyID("evoApps", "showBookingCalendarButton", PropertyTypeEnum.VirtualProperty),
	showTimekeepingButton: new PropertyID("evoApps", "showTimekeepingButton", PropertyTypeEnum.VirtualProperty),
	showResourceCalendarButton: new PropertyID("evoApps", "showResourceCalendarButton", PropertyTypeEnum.VirtualProperty),
	showOnClientButton: new PropertyID("evoApps", "showOnClientButton", PropertyTypeEnum.VirtualProperty),
	showSheetButton: new PropertyID("evoApps", "showSheetButton", PropertyTypeEnum.VirtualProperty),
	showTimelineButton: new PropertyID("evoApps", "showTimelineButton", PropertyTypeEnum.VirtualProperty),
	showTimelineTaskButton: new PropertyID("evoApps", "showTimelineTaskButton", PropertyTypeEnum.VirtualProperty),
	showPlanTemplateButton: new PropertyID("evoApps", "showPlanTemplateButton", PropertyTypeEnum.VirtualProperty),

	presenceStatusVisibility: new PropertyID("evoApps", 'presenceStatusVisibility'),
	/*
	 * app scoped properties - object is always sisAppName
	 */
	// timeline, resourceCalendar, term
	persInfPerRow: new PropertyID(appName, "persInfPerRow"), // [code:fkey,...]
	persInfPerRowSizes: new PropertyID(appName, "persInfPerRowSizes"), // [width,width,...]
	persInfPerRowTitles: new PropertyID(appName, "persInfPerRowTitles"), // [title,title,...]
	// timelineTask
	taskPerRow: new PropertyID(appName, "taskPerRow"), // [dqkey,...]
	taskPerRowSizes: new PropertyID(appName, "taskPerRowSizes"), // [width,width,...]
	taskPerRowTitles: new PropertyID(appName, "taskPerRowTitles"), // [title,title,...]
	// timeline, timelineTask, timekeeping
	auswertungButton: new PropertyID(appName, "auswertungButton"),
	kostAuswertungButton: new PropertyID(appName, 'kostAuswertungButton'),
	infoButton: new PropertyID(appName, "infoButton"),
// vis
	buchungVis: new PropertyID(appName, "buchungVis"),
	persurlVis: new PropertyID(appName, "persurlVis"),
	v2Vis: new PropertyID(appName, "v2Vis"),
	v2DataVis: new PropertyID(appName, "v2DataVis"),
	vlErrorVis: new PropertyID(appName, 'vlErrorVis'),
	koKeyVis: new PropertyID(appName, "koKeyVis"),
	persstVis: new PropertyID(appName, "persstVis"),
	planTemplVis: new PropertyID(appName, "planTemplVis"),
	stTagVis: new PropertyID(appName, "stTagVis"),
	stTagModelVis: new PropertyID(appName, "stTagModelVis"),
	stTagDetailVis: new PropertyID(appName, "stTagDetailVis"),
	stTagNormalVis: new PropertyID(appName, "stTagNormalVis"),
	stTagKernVis: new PropertyID(appName, "stTagKernVis"),
	stTagGlzVis: new PropertyID(appName, "stTagGlzVis"),
	istVis: new PropertyID(appName, "istVis"),
	feiertageVis: new PropertyID(appName, "feiertageVis"),
	taskZuVis: new PropertyID(appName, "taskZuVis"),
	statusForecastVis: new PropertyID(appName, "statusForecastVis"),
	sumAnVis: new PropertyID(appName, "sumAnVis"),
	sumAbVis: new PropertyID(appName, "sumAbVis"),
	sumPersurlVis: new PropertyID(appName, "sumPersurlVis"),
	sumPersurlWhenSollVis: new PropertyID(appName, "sumPersurlWhenSollVis"),
	sumSollVis: new PropertyID(appName, "sumSollVis"),
	sumNoTaskZuVis: new PropertyID(appName, "sumNoTaskZuVis"),
	sumNormalVis: new PropertyID(appName, "sumNormalVis"),
	sumKernVis: new PropertyID(appName, "sumKernVis"),
	sumGleitVis: new PropertyID(appName, "sumGleitVis"),
	wochenBelegVis: new PropertyID(appName, "wochenBelegVis"),
	bookingEndVis: new PropertyID(appName, "bookingEndVis"),
	sollIstVis: new PropertyID(appName, "sollIstVis"),
	//default overrides
	buchungDefault: new PropertyID(appName, "buchungDefault"),
	persurlDefault: new PropertyID(appName, "persurlDefault"),
	v2Default: new PropertyID(appName, "v2Default"),
	v2DataDefault: new PropertyID(appName, "v2DataDefault"),
	koKeyDefault: new PropertyID(appName, "koKeyDefault"),
	vlErrorDefault: new PropertyID(appName, "vlErrorDefault"),
	persstDefault: new PropertyID(appName, "persstDefault"),
	planTemplDefault: new PropertyID(appName, "planTemplDefault"),
	wochenBelegDefault: new PropertyID(appName, "wochenBelegDefault"),
	bookingEndDefault: new PropertyID(appName, "bookingEndDefault"),
	stTagDefault: new PropertyID(appName, "stTagDefault"),
	istDefault: new PropertyID(appName, "istDefault"),
	stTagModelDefault: new PropertyID(appName, "stTagModelDefault"),
	stTagDetailDefault: new PropertyID(appName, "stTagDetailDefault"),
	stTagNormalDefault: new PropertyID(appName, "stTagNormalDefault"),
	stTagKernDefault: new PropertyID(appName, "stTagKernDefault"),
	stTagGlzDefault: new PropertyID(appName, "stTagGlzDefault"),
	feiertageDefault: new PropertyID(appName, "feiertageDefault"),
	taskZuDefault: new PropertyID(appName, "taskZuDefault"),
	statusForecastDefault: new PropertyID(appName, "statusForecastDefault"),
	sumAnDefault: new PropertyID(appName, "sumAnDefault"),
	sumAbDefault: new PropertyID(appName, "sumAbDefault"),
	sumPersurlDefault: new PropertyID(appName, "sumPersurlDefault"),
	sumPersurlWhenSollDefault: new PropertyID(appName, "sumPersurlWhenSollDefault"),
	sumSollDefault: new PropertyID(appName, "sumSollDefault"),
	sumNoTaskZuDefault: new PropertyID(appName, "sumNoTaskZuDefault"),
	sumNormalDefault: new PropertyID(appName, "sumNormalDefault"),
	sumKernDefault: new PropertyID(appName, "sumKernDefault"),
	sumGleitDefault: new PropertyID(appName, "sumGleitDefault"),
	sollIstDefault: new PropertyID(appName, "sollIstDefault"),

	itemMinWidthPercentage: new PropertyID(appName, 'itemMinWidthPercentage'),
	pageSizeDefaultPerson: new PropertyID(appName, 'pageSizeDefaultPerson'),
	pageSizeMaxPerson: new PropertyID(appName, 'pageSizeMaxPerson'),
	pageSizeDefaultTask: new PropertyID(appName, 'pageSizeDefaultTask'),
	pageSizeMaxTask: new PropertyID(appName, 'pageSizeMaxTask'),
	maintenance_pageSizeMax: new PropertyID("maintenance", "pageSizeMax"),

	// Task
	taskTTL: new PropertyID(appName, "taskTTL"),
	// TaskZuDialog
	taskZuFixedSplit: new PropertyID(appName, "taskZuFixedSplit"),
	taskZuBlockOverlap: new PropertyID(appName, "taskZuBlockOverlap"),
	taskZuTooltipAdditionalContent: new PropertyID(appName, "taskZuTooltipAdditionalContent"),
	// PersstDialog
	persstDialog: new PropertyID(appName, "persstDialog"),
	// Freigabe
	showFreigabePers: new PropertyID(appName, "showFreigabePers"),
	freigabeKostVorgInput: new PropertyID("evoApps", "freigabeKostVorgInput", PropertyTypeEnum.VirtualProperty),
	freigabePersDateEdit: new PropertyID(appName, "freigabePersDateEdit"),
	showFreigabeKost: new PropertyID(appName, "showFreigabeKost"),
	freigabePersScope: new PropertyID(appName, "freigabePersScope"),
	freigabeKostScope: new PropertyID(appName, "freigabeKostScope"),
	freigabeKostDateEdit: new PropertyID(appName, "freigabeKostDateEdit"),
	freigabeKostText: new PropertyID(appName, "freigabeKostText"),
	freigabeKostIconOpen: new PropertyID(appName, "freigabeKostIconOpen"),
	freigabeKostIconDone: new PropertyID(appName, "freigabeKostIconDone"),
	//timeline, timelineTask, bookingCalendar, resourceCalendar, timekeeping
	printButton: new PropertyID(appName, "printButton"),
	//efile
	eFileButtonShowAuft: new PropertyID(appName, "eFileButtonShowAuft"),
	eFileButtonShowKost: new PropertyID(appName, "eFileButtonShowKost"),
	eFileButtonShowPers: new PropertyID(appName, "eFileButtonShowPers"),
	eFileButtonShowTask: new PropertyID(appName, "eFileButtonShowTask"),
	// entity text
	textAuft: new PropertyID("KONT", "TEXT", PropertyTypeEnum.Paramdiv, "AUFT"),
	textKost: new PropertyID("KONT", "TEXT", PropertyTypeEnum.Paramdiv, "KOSTENST"),

	overrideShowDeclineButton: new PropertyID("P40507", "DISPLAY", PropertyTypeEnum.Paramdiv, "ABLEHN"),
	//AzeDialog
	azeDialog_maxRowHeightOnInit: new PropertyID('newAzeDialog', 'maxRowHeightOnInit'),
	azeDialogButton: new PropertyID(appName, 'kontierungButton'),
	azeShowFromTo: new PropertyID(appName, 'showFromTo'),
	azeDialog_quickSelectWithText: new PropertyID("newAzeDialog", 'quickSelectWithText'),
	azeDialog_quickSelectInViewValues: new PropertyID("newAzeDialog", 'quickSelectInViewValues'),
	azeDialog_personsCopyPasteVis: new PropertyID(appName, 'personsCopyPasteVis'),

	// timekeeping: new bookingCalendar
	timekeepingWocheFreigebenButton: new PropertyID("timekeeping", "wocheFreigebenButton"),
	timekeepingWochenBelegButton: new PropertyID("timekeeping", "wochenBelegButton"),
	timekeepingDragAndDropEvents: new PropertyID("timekeeping", "dragAndDropEvents"),
	timekeepingResizeEvents: new PropertyID("timekeeping", "resizeEvents"),
	timekeepingMaxZoomLevel: new PropertyID("timekeeping", "maxZoomLevel"),
	viewMonthButton: new PropertyID(appName, "viewMonthButton"),
	viewWeekButton: new PropertyID(appName, "viewWeekButton"),
	viewDayButton: new PropertyID(appName, "viewDayButton"),
	// views only in timekeeping app
	viewWorkWeekButton: new PropertyID(appName, "viewWorkWeekButton"),
	// timekeeping: Behavior Calendar Color Settings
	timekeepingTodayColorPicker: new PropertyID(appName, "todayColorPicker"),
	timekeepingWeekendColPicker: new PropertyID(appName, "weekendColorPicker"),

	eventDialogButton: new PropertyID(appName, "eventDialogButton"),
	taskZuDialogButton: new PropertyID(appName, "taskZuDialogButton"),
	persstDialogButton: new PropertyID(appName, "persstDialogButton"),
	showDateModeSelect: new PropertyID(appName, "showDateModeSelect"),
	showViewModeSelect: new PropertyID(appName, "showViewModeSelect"),
	verrLaufButton: new PropertyID(appName, "verrLaufButton"),

	dataFilterMultipleRows: new PropertyID(appName, "dataFilterMultipleRows"),
	personInfoPanelContent: new PropertyID(appName, "personInfoPanelContent"),
}